/** The systems the guide to extending the screens shows the way for. */
export type GuideSystem = 'mac' | 'windows'

/**
 * Which system's way the guide opens with: the trainer's own, as the browser
 * names its platform (`navigator.userAgentData.platform`, else
 * `navigator.platform`). Anything but Windows gets the Mac's: the guide has
 * no other.
 */
export const guideSystem = (platform: string | undefined): GuideSystem =>
	/win/i.test(platform ?? '') ? 'windows' : 'mac'

/** The guide's pictures are in English and Polish; Polish for Polish only. */
export const guideLanguage = (locale: string): 'en' | 'pl' =>
	locale.toLowerCase().startsWith('pl') ? 'pl' : 'en'
